import { getIntl } from '@umijs/max';

type MessageValues = Record<string, string | number>;

export const formatLocaleMessage = (
  id: string,
  values?: MessageValues,
  fallback?: string,
): string => {
  const messages = getIntl().messages as Record<string, string>;
  const template = messages[id] ?? fallback ?? id;
  if (!values) {
    return template;
  }

  return template.replace(/\{(\w+)\}/g, (match, key) => {
    const value = values[key];
    return value === undefined ? match : String(value);
  });
};
